module.exports = __webpack_public_path__ + "da395a3bd255961f28193d5df554b047.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 57
// module chunks = 0